import { getQueryParams } from "@/utils/httpRequest";
import { lenderResourceShareService } from "@/modules/contacts/features/lender/store/resource-share-services/lender-resource-share-service";
import { RESOURCE_SHARE_SERVICE_TAG } from "@/modules/contacts/features/lender/utils/resource-share-service-tags";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";
import { defaultLenderResourceShareFilters } from "@/modules/contacts/features/lender/features/resource-share/utils/default-lender-resource-share-filters";

const getResourceShares = lenderResourceShareService.injectEndpoints({
  endpoints: builder => ({
    getResourceShares: builder.query({
      query: lenderId => `lenders/${lenderId}/resource-shares?${getQueryParams(defaultLenderResourceShareFilters)}`,
      providesTags: result =>
        result
          ? [
              ...result.items.map(({ resourceShareId }) => ({
                type: RESOURCE_SHARE_SERVICE_TAG,
                id: resourceShareId,
              })),
              { type: RESOURCE_SHARE_SERVICE_TAG, id: LIST_SERVICE_TAG },
            ]
          : [{ type: RESOURCE_SHARE_SERVICE_TAG, id: LIST_SERVICE_TAG }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetResourceSharesQuery } = getResourceShares;

